import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_f_tai_chi_walking_price_before_scratch~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__b'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_f_tai_chi_walking_price_before_scratch~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__b'
					),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_f_tai_chi_walking_price_before_scratch~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__b'
					),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_f_tai_chi_walking_price_before_scratch~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__b'
					),
			},
		},
	},
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_f_tai_chi_walking_price_before_scratch~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__c'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_f_tai_chi_walking_price_before_scratch~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__c'
					),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_f_tai_chi_walking_price_before_scratch~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__c'
					),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_f_tai_chi_walking_price_before_scratch~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '../../modules/Paywall/instances/experiments/web_f_tai_chi_walking_price_before_scratch/web_f_tai_chi_walking_price_before_scratch__c'
					),
			},
		},
	},
]

export default config
